import { useState } from "react";
import { useApolloClient } from "@apollo/client";
import { groupsSearch as groupQuery } from "../graphql/group.query";
import { groupAdapter } from "../adapters/group";
import { AdaptedGroup } from "../models";

type sponse = [
  AdaptedGroup,
  (scenarioId: string, originId: string, groupId: string) => void,
  boolean,
];

export const useGetGroup = (): sponse => {
  const client = useApolloClient();
  const [response, setResponse] = useState<AdaptedGroup>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const getGroup = async (scenarioId: string, originId: string, groupId: string) => {
    setLoading(true);
    try {
      const { data, errors } = await client.query({
        query: groupQuery,
        variables: {
          scenarioId,
          originId,
          filter: {
            fields: {
              isGrouped: { is: false },
              id: { eq: groupId },
            },
          },
        },
        fetchPolicy: "no-cache",
      });

      if (errors) {
        console.error("[Group error]: ", errors);
        setLoading(false);
        return null;
      }

      setResponse(groupAdapter(data?.cube?.groupsManagerSearch?.items?.[0]));
      setLoading(false);
    } catch (error) {
      console.error("[Group error]: ", error);
      setLoading(false);
    }
  };

  return [response, getGroup, loading];
};
